
const eatAndPlayConfig = {
  breakfast: {
    omelets: {
      sideGroup: "breakfastSides",
      image: "poker/eat-and-play/Omeletts---Natural.jpg",
      items: {
        plain: {
          price: 4.00
        },
        hamCheese: {
          price: 8.00
        },
        western: {
          price: 6.00
        },
        vegetarian: {
          price: 5.75
        }
      }
    },
    eggs: {
      sideGroup: "breakfastSides",
      image: "poker/eat-and-play/Eggs---Two-eggs-1-meat-choice.jpg",
      items: {
        twoEggs: {
          price: 6.00
        },
        twoEggsWithMeat: {
          price: 8.75
        },
        twoEggsWithPancake: {
          price: 7.75
        }
      }
    },
    batterBar: {
      sideGroup: "breakfastSides2",
      image: "poker/eat-and-play/Batter-Bar---3-Pancakes-Fruits.jpg",
      items: {
        base: {
          price: 5.00,
          options: {
            pancakes: {},
            frenchToast: {},
            waffle: { starred: true }
          }
        },
        sauces: {
          price: 3.00
        },
        fruits: {
          price: 2.00
        }
      }
    },
    healthyChoices: {
      sideGroup: "none",
      image: "poker/eat-and-play/Healthy-Choices---Fresh-Fruit-Salad.jpg",
      items: {
        fruitSalad: {
          price: 6.50
        },
        yogurtParfait: {
          price: 9.00
        },
        toastWithCheese: {
          price: 5.25
        }
      }
    },
    sandwiches: {
      sideGroup: "breakfastSides",
      image: "poker/eat-and-play/24h-breakfast-Breakfast-Sandwich.jpg",
      items: {
        blt: {
          price: 8.50
        },
        baconGrilledCheese: {
          price: 10.00
        },
        breakfastSandwich: {
          price: 8.00
        },
        smokedSalmonBagel: {
          price: 12.50,
          starred: true
        },
        breakfastBurrito: {
          price: 16.00
        },
        bagelBelt: {
          price: 9.00
        }
      }
    }
  },
  main: {
    appetizers: {
      sideGroup: "sauceSides",
      image: "poker/eat-and-play/Appetizers-Guacamole.jpg",
      items: {
        veggiePlate: {
          price: 6.50
        },
        guacamoleChips: {
          price: 7.75
        },
        saltPepperShrimp: {
          price: 9.50
        },
        chickenTenders: {
          price: 9.00
        },
        generalTao: {
          price: 7.25
        },
        vegetarianImperialRolls: {
          price: 6.25
        },
        smallPoutine: {
          price: 4.00
        },
        chickenNoodleSoup: {
          price: 3.00
        },
        fries: {
          price: 3.50
        },
        sweetPotatoFries: {
          price: 4.50,
          starred: true
        }
      }
    },
    coldSandwiches: {
      sideGroup: "regularSides",
      image: "poker/eat-and-play/Cold-Sandwiches-BLT.jpg",
      items: {
        clubSandwich: {
          price: 14.75
        },
        blt: {
          price: 8.50
        },
        tunaSaladSandwich: {
          price: 10.00
        },
        grilledChickenSaladSandwich: {
          price: 12.75
        },
        // californiaClub: {
        //   price: 19.75
        // }
      }
    },
    hotSandwiches: {
      sideGroup: "regularSides",
      image: "poker/eat-and-play/Hot-Burgers-Classic-Burger.jpg",
      items: {
        classicBurger: {
          price: 11.25
        },
        bigSlickBurger: {
          price: 16.25,
          starred: true
        },
        impossibleBurger: {
          price: 12.75
        },
        grilledCheese: {
          price: 10.00
        },
        wilenskySandwich: {
          price: 9.25
        },
        shishTaoukWrap: {
          price: 10.50
        },
        bigMacWrap: {
          price: 9.25
        },
        bangBangShrimpTacos: {
          price: 17.00
        },
        falafelWrap: {
          price: 13.00
        },
        friedChickenSandwich: {
          price: 14.00
        }
      }
    },
    landAndSea: {
      sideGroup: "regularSides",
      image: "poker/eat-and-play/Land-Sea-NYC-strip.jpg",
      items: {
        hamburgerSteak: {
          price: 11.75
        },
        grilledChickenBreast: {
          price: 10.25
        },
        boeufBourguignon: {
          price: 18.00
        },
        cajunHoneyButterGrilledSalmon: {
          price: 15.25
        },
        newYorkStrip: {
          price: 23.50,
          starred: true
        },
        fishAndChips: {
          price: 16.00
        },
        misoCod: {
          price: 16.00,
          starred: true
        }
      }
    },
    pasta: {
      sideGroup: "none",
      image: "poker/eat-and-play/Pasta-Pasta.jpg",
      items: {
        noodles: {
          price: 3.00
        },
        sauces: {
          price: 5.00
        },
        vegetables: {
          price: 3.00
        },
        meat: {
          price: 5.00
        },
        cheese: {
          price: 3.00
        }
      }
    },
    bowls: {
      sideGroup: "proteinSides",
      image: "poker/eat-and-play/Bowls-Bowl.jpg",
      items: {
        greekSalad: {
          price: {
            small: 7.50,
            large: 13.00
          }
        },
        caesarSalad: {
          price: {
            small: 8.50,
            large: 14.50
          }
        },
        greenGoddessSalad: {
          price: {
            small: 9.75,
            large: 17.50
          }
        },
        mexicaliSalad: {
          price: {
            small: 8.50,
            large: 12.00
          }
        },
        poutine: {
          price: 8.50
        },
        buddhaBowl: {
          price: 12.25,
          starred: true
        }
      }
    },
    pizza: {
      sideGroup: "pizzaSides",
      image: "poker/eat-and-play/Pizza.jpg",
      items: {
        margherita: {
          price: 9.25
        },
        pepperoni: {
          price: 10.25
        },
        allDressed: {
          price: 12.50
        },
        sweetDiavola: {
          price: 15.25,
          starred: true
        },
        extravaganza: {
          price: 15.25
        },
        cheesyGarlicBread: {
          price: 14.00
        }
      }
    },
    breakfastMenu24h: {
      sideGroup: "regularSides",
      image: "poker/eat-and-play/24h-breakfast-Breakfast-Sandwich.jpg",
      items: {
        hamCheese: {
          price: 8.00
        },
        westernOmelet: {
          price: 8.00
        },
        vegetarianOmelette: {
          price: 5.75
        },
        breakfastSandwich: {
          price: 8.00
        }
      }
    },
    desserts: {
      sideGroup: "none",
      image: "poker/eat-and-play/Desserts-Mousse-2.jpg",
      items: {
        yogurtParfait: {
          price: 9.00
        },
        freshFruitSalad: {
          price: 6.50
        },
        chocolateMousse: {
          price: 7.00
        },
        wildBerryTart: {
          price: 7.00,
          starred: true
        },
        slicedBanana: {
          price: 4.00
        },
        slicedApple: {
          price: 4.00
        },
        keyLimePie: {
          price: 10.00,
          starred: true
        },
        carrotCake: {
          price: 10.00
        }
      }
    }
  },
  extras: {
    proteinSides: {
      items: {
        grilledChicken: {
          price: 9.00
        },
        cajunSalmon: {
          price: 15.00
        },
        chickenTenders: {
          price: 10.00
        },
        falafel: {
          price: 4.00
        },
        grilledTofu: {
          price: 7.00
        }
      }
    },
    sauceSides: {
      items: {
        mapleBbq: {
          price: 3.00
        },
        hotSauce: {
          price: 4.00
        },
        chipotleMayo: {
          price: 3.00
        },
        generalTaoSauce: {
          price: 2.00
        },
        thaiSweetChili: {
          price: 2.00
        },
        jalapenoMayo: {
          price: 5.00
        }
      }
    },
    pizzaSides: {
      starred: true,
      vegetables: {
        items: {
          redOnions: {
            price: 0.50
          },
          peppers: {
            price: 0.50
          },
          mushrooms: {
            price: 0.50
          },
          olives: {
            price: 0.50
          }
        }
      },
      meat: {
        items: {
          bacon: {
            price: 6.00
          },
          sausage: {
            price: 3.00
          },
          pepperoni: {
            price: 3.00
          },
          soppressata: {
            price: 5.00
          }
        }
      },
      cheese: {
        items: {
          mozzarella: {
            price: 3.00
          },
          feta: {
            price: 3.00
          }
        }
      }
    },
    regularSides: {
      items: {
        fries: {
          price: 5.00
        },
        smallGoddessSalad: {
          price: 7.50
        },
        smallGreekSalad: {
          price: 8.50
        },
        smallCaesarSalad: {
          price: 9.75
        },
        avocadoHalf: {
          price: 4.00
        },
        sauteedVegetables: {
          price: 5.00
        },
        whiteRice: {
          price: 3.00
        },
        mashedPotatoes: {
          price: 5.00,
          starred: true
        },
        sweetPotatoFries: {
          price: 5.00,
          starred: true
        },
        smallPoutine: {
          price: 6.00
        },
        sweetPotatoPoutine: {
          price: 7.00,
          starred: true
        }
      }
    },
    breakfastSides: {
      items: {
        breakfastPotatoes: {
          price: 3.00
        },
        avocadoHalf: {
          price: 3.00
        },
        fruitSalad: {
          price: 3.00
        },
        bakedBeans: {
          price: 2.00
        },
        egg: {
          price: 2.00
        },
        bacon: {
          price: 5.00
        },
        sausage: {
          price: 4.00
        },
        ham: {
          price: 4.00
        },
        toast: {
          price: 4.00
        },
        // slicedTomatoes: {
        //   price: 4.00
        // }
      }
    }
  }
};

export default eatAndPlayConfig;
